export interface ContentData {
  version: 1;
  purpose: string;
  limitations: string;
  parameters: { name: string; value: string; unit: string }[];
  media: { id: string; sha256: string }[];
}
export const emptyContent = (): ContentData => ({
  version: 1,
  purpose: '',
  limitations: '',
  parameters: [],
  media: [],
});
export function parseContent(json: string | undefined): ContentData {
  if (!json) return emptyContent();
  const value = JSON.parse(json) as ContentData;
  if (
    value.version !== 1 ||
    typeof value.purpose !== 'string' ||
    typeof value.limitations !== 'string' ||
    !Array.isArray(value.parameters) ||
    !Array.isArray(value.media)
  )
    throw new Error('资料格式不兼容');
  return value;
}
export function contentFrames(content: string): string[] {
  const bytes = new TextEncoder().encode(content),
    decoder = new TextDecoder('utf-8', { fatal: true });
  const values: string[] = [];
  let offset = 0;
  while (offset < bytes.length) {
    const colon = bytes.indexOf(58, offset);
    if (colon < 0) throw new Error('资料帧格式异常');
    const raw = decoder.decode(bytes.slice(offset, colon));
    if (!/^(0|[1-9][0-9]*)$/.test(raw)) throw new Error('资料帧长度异常');
    const length = Number(raw);
    if (!Number.isSafeInteger(length) || length > bytes.length - colon - 1)
      throw new Error('资料帧越界');
    offset = colon + 1;
    values.push(decoder.decode(bytes.slice(offset, offset + length)));
    offset += length;
  }
  return values;
}
export function extensionFromFrames(content: string | null | undefined): string {
  if (!content) return '';
  const frames = contentFrames(content);
  return frames.at(-2) === 'CA04-CONTENT-V1' ? frames.at(-1)! : '';
}

export function syntheticEntryQuery() {
  return (
    '?synLive=1' +
    (typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).has('dataWorkspace')
      ? '&dataWorkspace=' +
        encodeURIComponent(new URLSearchParams(window.location.search).get('dataWorkspace')!)
      : '') +
    (import.meta.env.DEV &&
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('synMedia') === '1'
      ? '&synMedia=1'
      : '') +
    (import.meta.env.DEV &&
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('synAssessment') === '1'
      ? '&synAssessment=1'
      : '') +
    (import.meta.env.DEV &&
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('synMonitoring') === '1'
      ? '&synMonitoring=1'
      : '')
  );
}
